<template>
  <div class="radio-group">
    <template v-for="(group, index) in groups" :key="index">
      <input
        :id="`option-${group.name}`"
        v-model="selectedGroup"
        type="radio"
        name="mode-selector"
        :value="group"
      >
      <label
        :for="`option-${group.name}`"
        :style="{ flex: flexStyles }"
        :title="group.name"
        @click.prevent="toggleSelection(group)"
      >
        {{ group.name }}
      </label>
    </template>
  </div>
</template>

<script>

export default {
  name: 'ImageGroupSelector',
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    imageGroupId: {
      type: Number,
      default: 0,
    },
  },
  emits: ['change'],
  computed: {
    flexStyles() {
      return this.groups.length === 3 ? '1 1 33.333%' : '1 1 50%';
    },
    selectedGroup() {
      return this.groups.find((group) => group.id === this.imageGroupId) || null;
    },
  },
  methods: {
    toggleSelection(group) {
      if (group.id !== this.imageGroupId) {
        this.$emit('change', group.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-group {
  width: 100%;
  margin: 0;
  flex-wrap: wrap;
  display: flex;

  input[type=radio] + label {
    padding: 6px;
    min-width: 0;
    font-size: 0.875rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
